
import {
  Component,
  Vue,
  Prop,
  Model,
  Emit,
  Watch
} from "vue-property-decorator";
import ModalHeader from "@/components/modal-header.vue";
import SvgImg from "@/components/videoPaly/index.vue";

@Component({
  components: {
    ModalHeader,
    SvgImg
  }
})
export default class CandidateAnswerSection extends Vue {
  name = "audit-candidate";
  @Prop() data!: any;
  @Prop() answerIndex!: number;
  @Prop() active!: boolean;
  @Prop() isAudio!: boolean;

  mounted() {
    console.log(this.data);
  }

  // 是否存在居中播放图标
  isShowSvg(val: string) {
    return (
      val &&
      String(val)
        .substr(-3, 3)
        .toLowerCase() !== "mp3"
    );
  }

  get answerList() {
    return this.data.answerList.filter((a: any) =>
      [1, 7, 6, 8, 5].includes(a.type)
    );
  }

  onClickAsrItem(asrItem: any, appendIndex = -1) {
    this.$emit("on-click-asr-item", {
      answerIndex: this.answerIndex,
      appendIndex: appendIndex,
      time: asrItem.bg
    });
  }

  //asr内容
  asrText(list: any) {
    if (list.length === 0) {
      return "未识别出内容";
    }
    let text = "";
    list.forEach((d: any) => {
      text += d.txt;
    });
    return text;
  }
}
